export default function textValidation(value, validationCallback) {
    const regex = /^[a-zA-Zа-яА-Я-]*$/;
    if (regex.test(value)) {
        validationCallback(value)
    }
}